// extracted by mini-css-extract-plugin
export default {"checkbox":"CheckBox_checkbox__diKVk"};